import { profileState } from "@/atoms/user/profile-state";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import {
  PartneAdminPath,
  PartnerNotificationPath,
  PartnerOrderManagePath,
  PartnerOrderPath,
  PartnerQuotePath,
} from "../../../common/enum/path";
import { Body14Strong } from "../../typography/Body14Strong";

interface Props {}

export const GlobalPartnerHeader: React.FC<Props> = ({}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const profile = useRecoilValue(profileState);

  const links: {
    name: string;
    path: string;
    subs: string[];
  }[] = [
    { name: "홈", path: "/", subs: [] },
    {
      name: "상품 발주",
      path: PartnerOrderPath.ORDER,
      subs: Object.values(PartnerOrderPath).map(String),
    },
    {
      name: "발주 관리",
      path: PartnerOrderManagePath.MANAGE_ORDER,
      subs: Object.values(PartnerOrderManagePath).map(String),
    },
    {
      name: "견적서 관리",
      path: PartnerQuotePath.QUOTES,
      subs: Object.values(PartnerQuotePath).map(String),
    },
    {
      name: "공지사항",
      path: "/notification",
      subs: Object.values(PartnerNotificationPath).map(String),
    },
  ];

  const navigateToMyProfile = () => {
    navigate(PartneAdminPath.MY_PROFILE);
  };

  return (
    <div className="box-border flex h-[64px] w-full items-center justify-center bg-primary-dark-gray px-[24px] py-[14px]">
      <div className="box-border flex h-[40px] w-[1872px] items-center justify-between px-[32px]">
        <div className="box-border flex h-[40px] w-[119px] items-center justify-center p-[8px]">
          <img src="/img/logo_white_tagline.png" alt="Logo" />
        </div>

        <div className="box-border flex h-[22px] w-[486px] items-center justify-between">
          <div className="box-border flex h-full w-full items-center justify-between">
            {links.map((link) => (
              <div key={link.path} onClick={() => navigate(link.path)}>
                <Body14Strong
                  className={`${
                    link.path === "/"
                      ? location.pathname === link.path
                        ? "text-white"
                        : "text-gray-500"
                      : link.subs.some((sub) =>
                          location.pathname.startsWith(sub)
                        )
                      ? "text-white"
                      : "text-gray-500"
                  } cursor-pointer`}
                >
                  {link.name}
                </Body14Strong>
              </div>
            ))}
          </div>
        </div>
        <div className="box-border flex h-[22px] w-[128px] items-center justify-end text-white ">
          <div
            className="box-border h-full pr-[16px] border-r border-primary-gray cursor-pointer"
            onClick={navigateToMyProfile}
          >
            <Body14Strong className="text-right">{profile.name}님</Body14Strong>
          </div>
          <div
            className="box-border h-full pl-[16px]"
            onClick={() => {
              localStorage.removeItem("accessToken");
              sessionStorage.removeItem("accessToken");
              window.location.reload();
            }}
          >
            <Body14Strong className="cursor-pointer">Logout</Body14Strong>
          </div>
        </div>
      </div>
    </div>
  );
};
